export default {"src":"/_next/static/media/hrms.b7ad418f.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};